import { useEffect, useState } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const Home = () => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 4000,
  };

  const images = [
    {
      src: "/assests/Frame1.png",
      mobileSrc: "/assests/mblFrame1.png",
      link: "/home",
    },
    {
      src: "/assests/Frame2.png",
      mobileSrc: "/assests/mblFrame2.png",
      link: "/partner",
    },
  ];

  const handleImageClick = (link) => {
    window.location.href = link;
  };

  return (
    <div className="w-full mt-[80px] fhd:mt-[100px]">
      <style>
        {`
          .custom-dots .slick-dots li button:before {
            font-size: 12px;
            color: #1d4ed8;
            opacity: 0.6;
          }
          .custom-dots .slick-dots li.slick-active button:before {
            color: #2563eb;
            opacity: 1;
          }
        `}
      </style>
      <Slider {...settings} className="custom-dots">
        {images.map((item, idx) => (
          <div
            key={idx}
            onClick={idx === 1 ? () => handleImageClick(item.link) : undefined}
            className="cursor-pointer focus:outline-none"
            tabIndex={-1}
          >
            <img
              src={isMobile ? item.mobileSrc : item.src}
              alt={`Slide ${idx}`}
              className="w-full h-[85vh] rounded-xl select-none"
              draggable={false}
            />
          </div>
        ))}
      </Slider>
    </div>
  );
};

export default Home;
